import cx from 'classnames';
import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { Spinner } from '@dx-ui/osc-spinner';
import { Text } from '@dx-ui/global-ui-prism';

type FormHelpMessage = {
  isLoading?: boolean;
  message?: string | string[];
} & React.ComponentProps<'div'>;

const FormHelpMessage = ({ ref, className, message, isLoading, id, ...rest }: FormHelpMessage) => {
  const { t } = useTranslation('osc-form');
  const messages = Array.isArray(message) ? message : [message];

  return (
    <div id={id} className="grid gap-1 pt-1">
      {isLoading ? (
        <div className="flex gap-2">
          <Spinner size="sm" />
          <Text>{t('loading')}</Text>
        </div>
      ) : (
        messages &&
        messages?.map((value, index) => (
          <div
            ref={ref}
            className={cx('items-center space-x-2', className)}
            key={`help-message-${index + 1}`}
            {...rest}
          >
            <Text size="sm" className="text-surface-muted">
              {value}
            </Text>
          </div>
        ))
      )}
    </div>
  );
};

export { FormHelpMessage };
export default FormHelpMessage;
